import { SuperbatchResourceRecorder } from '../src/SuperbatchResourceRecorder';

export const superbatchCSSRecorder = new SuperbatchResourceRecorder(false);
export const superbatchJSRecorder = new SuperbatchResourceRecorder(true);
